import { ContactFolder, createSelector } from '../../shared';

import type { HubState } from '../state';
import { AppState, SearchQuery, getDisplayedContactFolders } from '../../appstate';
import {
    getPublicFolderForCurrentHubPersona,
    isPublicFolderCanModifyForCurrentHubPersona,
    isPublicFolderCanCreateForCurrentHubPersona,
} from './publicFolderSelector';

export const getCurrentHubPersonaWritableContactFolderId = createSelector<
    AppState,
    HubState,
    ContactFolder,
    ContactFolder[],
    string,
    SearchQuery,
    ContactFolder,
    boolean,
    boolean,
    string
>(
    'getCurrentHubPersonaWritableContactFolderId',
    [
        (appState: AppState) => appState.data.contactFoldersState.defaultContactFolder,
        getDisplayedContactFolders,
        (appState: AppState) => appState.view.navigationState.clickedLeftNavItemId,
        (appState: AppState) => appState.view.navigationState.currentQuery,
        getPublicFolderForCurrentHubPersona,
        isPublicFolderCanModifyForCurrentHubPersona,
        isPublicFolderCanCreateForCurrentHubPersona,
    ],
    (
        defaultContactFolder,
        displayedContactFolders,
        clickedLeftNavItemId,
        searchQuery,
        publicFolder,
        publicFolderCanModify,
        publicFolderCanCreate
    ) => {
        if (publicFolderCanModify || publicFolderCanCreate) {
            return publicFolder.id;
        }

        if (clickedLeftNavItemId && !searchQuery) {
            const maybeDisplayedFolder = displayedContactFolders.find(
                displayed => displayed.id === clickedLeftNavItemId && !displayed.isReadOnly
            );

            const contactFolder = maybeDisplayedFolder || defaultContactFolder;
            return contactFolder ? contactFolder.id : undefined;
        } else {
            return defaultContactFolder ? defaultContactFolder.id : undefined;
        }
    }
);
